import { render, staticRenderFns } from "./my-table.vue?vue&type=template&id=5c8adfc2&scoped=true"
import script from "./my-table.vue?vue&type=script&lang=js"
export * from "./my-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8adfc2",
  null
  
)

export default component.exports